const cmaOps = require('./cmaOperations');

let newArr = null;

function getValue(val) {
  if (val && val !== Infinity) return val;
  return 0;
}

module.exports = function (fys, arrayLength, cma_bsa_values, cma_bs_values, cma_pl_values) {

  cma_bsa_values.cma_bsa_3 = cma_bs_values.cma_bs_72;

  // cma_bsa_values.cma_bsa_4
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = getValue(cma_bsa_values.cma_bsa_3[i]/(cma_pl_values.cma_pl_11[i]/fys[i].months));
  }
  cma_bsa_values.cma_bsa_4 = newArr;

  cma_bsa_values.cma_bsa_5 = cma_bs_values.cma_bs_73;

  // cma_bsa_values.cma_bsa_6
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = getValue(cma_bsa_values.cma_bsa_5[i]/(cma_pl_values.cma_pl_12[i]/fys[i].months));
  }
  cma_bsa_values.cma_bsa_6 = newArr;

  cma_bsa_values.cma_bsa_8 = cma_bs_values.cma_bs_77;

  // cma_bsa_values.cma_bsa_9
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = getValue(cma_bsa_values.cma_bsa_8[i]/(cma_pl_values.cma_pl_14[i]/fys[i].months));
  }
  cma_bsa_values.cma_bsa_9 = newArr;

  cma_bsa_values.cma_bsa_10 = cma_bs_values.cma_bs_78;

  // cma_bsa_values.cma_bsa_11
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = getValue(cma_bsa_values.cma_bsa_10[i]/(cma_pl_values.cma_pl_15[i]/fys[i].months));
  }
  cma_bsa_values.cma_bsa_11 = newArr;

  cma_bsa_values.cma_bsa_12 = cma_bs_values.cma_bs_74;

  // cma_bsa_values.cma_bsa_13
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = getValue(cma_bsa_values.cma_bsa_12[i]/(cma_pl_values.cma_pl_28[i]/fys[i].months));
  }
  cma_bsa_values.cma_bsa_13 = newArr;

  cma_bsa_values.cma_bsa_14 = cma_bs_values.cma_bs_75;

  // cma_bsa_values.cma_bsa_15
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = getValue(cma_bsa_values.cma_bsa_14[i]/(cma_pl_values.cma_pl_90[i]/fys[i].months));
  }
  cma_bsa_values.cma_bsa_15 = newArr;

  cma_bsa_values.cma_bsa_16 = cma_bs_values.cma_bs_66;

  // cma_bsa_values.cma_bsa_17
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = getValue(cma_bsa_values.cma_bsa_16[i]/(cma_pl_values.cma_pl_2[i]/fys[i].months));
  }
  cma_bsa_values.cma_bsa_17 = newArr;

  cma_bsa_values.cma_bsa_18 = cma_bs_values.cma_bs_67;

  // cma_bsa_values.cma_bsa_19
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = getValue(cma_bsa_values.cma_bsa_18/(cma_pl_values.cma_pl_3[i]/fys[i].months));
  }
  cma_bsa_values.cma_bsa_19 = newArr;

  cma_bsa_values.cma_bsa_20 = cma_bs_values.cma_bs_79;

  cma_bsa_values.cma_bsa_24 = cma_bs_values.cma_bs_63;
  cma_bsa_values.cma_bsa_25 = cma_bs_values.cma_bs_64;

  cma_bsa_values.cma_bsa_22 = cma_bs_values.cma_bs_59;
  cma_bsa_values.cma_bsa_23 = cmaOps.sum(cma_bsa_values.cma_bsa_24, cma_bsa_values.cma_bsa_25);
  cma_bsa_values.cma_bsa_26 = cma_bs_values.cma_bs_69;
  cma_bsa_values.cma_bsa_27 = cma_bs_values.cma_bs_80;
  cma_bsa_values.cma_bsa_28 = cma_bs_values.cma_bs_81;

  cma_bsa_values.cma_bsa_21 = cmaOps.sum(cma_bsa_values.cma_bsa_22, cma_bsa_values.cma_bsa_23, cma_bsa_values.cma_bsa_26, cma_bsa_values.cma_bsa_27, cma_bsa_values.cma_bsa_28);

  cma_bsa_values.cma_bsa_29 = cmaOps.sum(cma_bsa_values.cma_bsa_3, cma_bsa_values.cma_bsa_5, cma_bsa_values.cma_bsa_8, cma_bsa_values.cma_bsa_10, cma_bsa_values.cma_bsa_12, cma_bsa_values.cma_bsa_14, cma_bsa_values.cma_bsa_16, cma_bsa_values.cma_bsa_18, cma_bsa_values.cma_bsa_20, cma_bsa_values.cma_bsa_21);

  cma_bsa_values.cma_bsa_31 = cma_bs_values.cma_bs_8;

  // cma_bsa_values.cma_bsa_32
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = getValue(cma_bsa_values.cma_bsa_31[i]/((cma_bs_values.cma_bs_71[i] - cma_bs_values.cma_bs_71[i-1] + cma_pl_values.cma_pl_10[i])/fys[i].months));
  }

  cma_bsa_values.cma_bsa_32 = newArr;

  cma_bsa_values.cma_bsa_33 = cma_bs_values.cma_bs_9;

  cma_bsa_values.cma_bsa_34 = cma_bs_values.cma_bs_12;

  cma_bsa_values.cma_bsa_36 = cma_bs_values.cma_bs_6;
  cma_bsa_values.cma_bsa_37 = cma_bs_values.cma_bs_10;
  cma_bsa_values.cma_bsa_38 = cma_bs_values.cma_bs_11;
  cma_bsa_values.cma_bsa_39 = cma_bs_values.cma_bs_13;
  cma_bsa_values.cma_bsa_40 = cma_bs_values.cma_bs_19;

  cma_bsa_values.cma_bsa_35 = cmaOps.sum(cma_bsa_values.cma_bsa_36, cma_bsa_values.cma_bsa_37, cma_bsa_values.cma_bsa_38, cma_bsa_values.cma_bsa_39, cma_bsa_values.cma_bsa_40);

  cma_bsa_values.cma_bsa_41 = cmaOps.sum(cma_bsa_values.cma_bsa_31, cma_bsa_values.cma_bsa_33, cma_bsa_values.cma_bsa_34, cma_bsa_values.cma_bsa_35);

  return cma_bsa_values;
};



// WEBPACK FOOTER //
// ./src/cma/calculations_BSA.js